import { Moment } from 'moment';
import VehicleStatus from '@/dossier/constants/VehicleStatus';
import { DossierId } from '@/dossier/models/AbstractDossier';
import { WorkshopTeamId } from '@/general/models/WorkshopTeam';

export default class UnplannedEventUpdate {
  dossierId!: DossierId;
  teamId: WorkshopTeamId | null = null;
  vehicleStatus: VehicleStatus | null = null;
  checkedInAt!: Moment;
}